import React from 'react';

import { Input, Select } from 'antd';
import { useSelector } from 'react-redux';

import { RootState } from '@share/utils';
import { ILuxuryHomeLocation } from '@share/common-types';
import { handleNumericKeyDown } from '@utils';

import './style.scss';

interface IProps {
  hideLocations?: boolean;
  disabledLocations?: boolean;
  disabledSearch?: boolean;
  disabledOcuppancy?: boolean;
  disabledBedrooms?: boolean;
  disabledBathrooms?: boolean;

  selectedLocation: string | null;
  selectedOcuppancy: string;
  selectedBedrooms: string;
  selectedBathrooms: string;
  search: string;

  setSelectedLocation: (location: string | null) => void;
  setSelectedOcuppancy: (ocuppancy: string) => void;
  setSelectedBedrooms: (bedrooms: string) => void;
  setSelectedBathrooms: (bathrooms: string) => void;
  setSearch: (search: string) => void;
}

export const LuxuryHomesPropertiesFilters: React.FC<IProps> = ({ hideLocations, disabledLocations, disabledSearch, disabledOcuppancy, disabledBedrooms, disabledBathrooms, selectedLocation, selectedOcuppancy, selectedBedrooms, selectedBathrooms, search, setSelectedLocation, setSelectedOcuppancy, setSelectedBedrooms, setSelectedBathrooms, setSearch }) => {

  const { locations } = useSelector((state: RootState) => state.luxuryHomesStore);

  const handleNumberInputChange = (e: React.ChangeEvent<HTMLInputElement>, setValue: (value: string) => void) => {
    try {
      const value = e.target.value;
      if (value === '') {
        setValue('');
      } else {
        const numberValue = parseInt(value);

        if(numberValue >= 0) {
          setValue(numberValue.toString());
        } else {
          e.preventDefault();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <div className="featured-properties__filters">
      {!hideLocations && (
        <Select 
          value={selectedLocation} 
          onChange={setSelectedLocation} 
          placeholder="Select Destination" 
          filterOption={(input, option) =>
            ((option?.label ?? '') as string).toLowerCase().includes(input.toLowerCase())
          }
          disabled={disabledLocations}
          options={locations?.map((d: ILuxuryHomeLocation) => ({ label: d.name, value: d.id }))}
          showSearch
          allowClear 
        >
        </Select>)}

      <Input value={search} allowClear placeholder="Property Name" onChange={(e) => setSearch(e.target.value)} disabled={disabledSearch} />

      <Input
        value={selectedOcuppancy}
        type="number"
        allowClear
        placeholder="Guests"
        onChange={(e) => handleNumberInputChange(e, setSelectedOcuppancy)}
        onKeyDown={handleNumericKeyDown}
        disabled={disabledOcuppancy} />

      <Input
        value={selectedBedrooms}
        type="number"
        allowClear
        placeholder="Bedrooms"
        onChange={(e) => handleNumberInputChange(e, setSelectedBedrooms)}
        onKeyDown={handleNumericKeyDown}
        disabled={disabledBedrooms} />
      
      <Input 
        value={selectedBathrooms} 
        type="number" 
        allowClear 
        placeholder="Bathrooms" 
        onChange={(e) => handleNumberInputChange(e, setSelectedBathrooms)} 
        onKeyDown={handleNumericKeyDown}
        disabled={disabledBathrooms} />
    </div>
  );
};
